import { PolicyType } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { AutoPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Box, Stack } from '@mui/material';
import React from 'react';

import DiscountsCard from '../../../components/InfoCards/DiscountsCard';
import HeaderTypography from '../HeaderTypography';
import PolicyDetailsCard from '../PolicyDetailsCard';
import CoveragesCard from './CoveragesCard';
import DriversCard from './DriversCard';

interface Props {
  autoPolicy: AutoPolicy;
  policyType: PolicyType.AUTO | PolicyType.MC;
}

const AutoPolicyDetails: React.FC<Props> = ({ autoPolicy, policyType }) => {
  const isNanoPolicy = autoPolicy.policySummary.nanoPolicy;
  const getHeaderText = () => {
    if (isNanoPolicy) return 'Named Non-owner policy';
    return 'Auto policy';
  };
  return (
    <Box
      sx={{
        width: 1,
        px: {
          mobile: 2,
          tablet: 4,
          desktop: 7,
        },
        py: {
          mobile: 2,
          tablet: 2,
          desktop: 9,
        },
      }}
    >
      <HeaderTypography text={getHeaderText()} />
      <Stack
        direction={{ mobile: 'column', desktop: 'row' }}
        spacing={3}
        width={1}
        sx={{ marginTop: '24px' }}
      >
        <Stack spacing={{ mobile: 2, tablet: 3 }} width={1}>
          <PolicyDetailsCard policy={autoPolicy} isNanoPolicy={isNanoPolicy} />
          {autoPolicy?.driverCoverages &&
            autoPolicy.driverCoverages.length > 0 && (
              <DriversCard data={autoPolicy.driverCoverages} />
            )}
          <CoveragesCard data={autoPolicy} isNanoPolicy={isNanoPolicy} />
        </Stack>
        {autoPolicy.discounts?.length > 0 && (
          <Stack
            spacing={3}
            data-testid="discountsCardContainer"
            sx={{ maxWidth: { mobile: 1, desktop: 358 }, width: 1 }}
          >
            <DiscountsCard
              discounts={autoPolicy.discounts}
              policyType={policyType}
            />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default AutoPolicyDetails;
